// extracted by mini-css-extract-plugin
module.exports = {"icon":"s_icon__3Ppqe","rotate":"s_rotate__1LMfn"};